// import { createRouter, createWebHashHistory, createWebHistory } from "vue-router";
import { createRouter, createWebHashHistory } from "vue-router";
import Home from "../views/Home.vue";
import Bibliotecas from "../views/Bibliotecas.vue";
import Catalogo    from "../views/Catalogo.vue";
import Autores     from "../views/Autores.vue";
import AutorDetail from "../views/AutorDetail.vue";
import AutorForm from "../views/AutorForm.vue";
import BiblioDetail from "../views/BiblioDetail.vue";
import LinksExternos from "../views/LinksExternos.vue";
import LibrosCirculan from "../views/LibrosCirculan.vue";
import News from "../views/News.vue";
import NewsDetail from "../views/NewsDetail.vue";


const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/bibliotecas",
    name: "Bibliotecas",
    component: Bibliotecas,
  }, 
  {
    path: "/biblioteca/:id",
    name: "BiblioDetail",
    props: true,
    component: BiblioDetail,
  },      
  {
    path: "/catalogo/:filterHome?",
    props:true,
    name: "Catalogo",
    component: Catalogo,
  },  
  {
    path: "/autores",
    name: "Autores",
    component: Autores,
  },
  {
    path: "/autor/:id",
    name: "AutorDetail",
    props:true,
    component: AutorDetail,
  },  
  {
    path: "/autor-inscripcion",
    name: "AutorForm",
    component: AutorForm,
  },    
  
  {
    path: "/catalogos-digitales",
    name: "LinksExternos",
    component: LinksExternos,
  },  

  {
    path: "/libros-circulan",
    name: "LibrosCirculan",
    component: LibrosCirculan,
  },  
  {
    path: "/novedades",
    name: "Novedades",
    component: News,
  },  
  {
    path: "/novedad/:slug",
    name: "NewsDetail",
    component: NewsDetail,
  }

];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
